import { NAME } from './constants';

export const CLEAR_OTP = `${NAME}/CLEAR_OTP`;
export const LOAD_OTP_BY_FLIGHT = `${NAME}/LOAD_OTP_BY_FLIGHT`;
export const LOAD_OTP_SUCCESS = `${NAME}/LOAD_OTP_SUCCESS`;
export const LOAD_FAIL = `${NAME}/LOAD_FAIL`;
export const START_SPINNER = `${NAME}/START_SPINNER`;
export const END_SPINNER = `${NAME}/END_SPINNER`;
